export default __webpack_public_path__ + "static/media/icon_zygomatic.ccd1e0fd.png";